import {ParamMap} from "@angular/router";

export class MutableQueryMap {
  private internalMap: Map<string, string[]>;

  constructor(paramMap: ParamMap) {
    this.internalMap = new Map();
    paramMap.keys.forEach(key => {
      const values = paramMap.getAll(key);
      this.internalMap.set(key, [...values]); // clone the array
    });
  }

  has(key: string): boolean {
    return this.internalMap.has(key) && this.internalMap.get(key)?.length !== 0;
  }

  keys(): Array<string> {
    return Array.from(this.internalMap.keys());
  }

  get(key: string): string | null {
    const values = this.internalMap.get(key);
    return values?.[0] ?? null;
  }

  getAll(key: string): string[] {
    return this.internalMap.get(key) ?? [];
  }

  set(key: string, value: string | string[]): void {
    this.internalMap.set(key, Array.isArray(value) ? value : [value]);
  }
}
